import { render, staticRenderFns } from "./dataIndex.vue?vue&type=template&id=280d699e&scoped=true"
import script from "./dataIndex.vue?vue&type=script&lang=ts"
export * from "./dataIndex.vue?vue&type=script&lang=ts"
import style0 from "./dataIndex.vue?vue&type=style&index=0&id=280d699e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "280d699e",
  null
  
)

export default component.exports